module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }, [_c('h1', {
    staticClass: "contentsHead"
  }, [_vm._v("CONTENTS")])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/e9780545756211_title001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ded001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545756211_fm001"
    }
  }, [_vm._v("MAP")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545756211_fm002"
    }
  }, [_vm._v("PROLOGUE: THE TRAVELER’S SECRET")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545756211_ch001"
    }
  }, [_vm._v("1: THE KNIGHT OF COBBLESTOWN")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780545756211_ch002"
    }
  }, [_vm._v("2: THE FESTIVAL")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: THE AX")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: A KNIGHT IN THE WOODS")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: THE PEASANT’S MOTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: THE TERRACE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: THE MAD PRINCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: UNWOVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: THE LOOM")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: REFLECTION")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: PICKING PANSIES")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: THE KING’S CHARGE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: THE WESTERLY MANSION")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: THE MOUNTAIN WITCH")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: THE SHADOWED BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: A STONY CONSCIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17: BEARS AND BEESWAX")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18: WESTMINE CASTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19: HILVAR’S TREASURE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20: THE MASTER THREADER")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21: MYLAN")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22: THE ETHEREAL DANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23: THE WEAVER’S GATE")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24: THE WHISPERING LIGHTS")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25: BROOKLET’S FLIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26: EVEN IN DEATH")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27: ALTERATION")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28: THE PEASANT OF AVëRAND")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_bm001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: A PROMISING SEAMSTRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_ata001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR’S")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780545756211_copy001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104797d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545756211_toc001.vue
// module id = 63
// module chunks = 0